import { Quota, QuotaResponse } from "../coworkerApiCalls/Quotas/QuotasTypes";

const quotaResponseToQuota = (quota: QuotaResponse): Quota => {
    return {
        departmentId: quota.departmentId,
        spaceId: quota.spaceId,
        value: quota.value,
        departmentName: quota.departmentName
    };
};

const quotaResponsesToQuotas = (quotas: QuotaResponse[]): Quota[] => {
    return quotas.map((quota: QuotaResponse): Quota => quotaResponseToQuota(quota));
};

export { quotaResponseToQuota, quotaResponsesToQuotas };